/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface YoutubeSubtitlesResponse {
    kind?: YoutubeSubtitlesResponse.KindEnum;
    subtitleUrl?: string;
}
export namespace YoutubeSubtitlesResponse {
    export type KindEnum = 'NONE' | 'MANUAL' | 'AUTOMATIC' | 'CHECK_FAILED';
    export const KindEnum = {
        NONE: 'NONE' as KindEnum,
        MANUAL: 'MANUAL' as KindEnum,
        AUTOMATIC: 'AUTOMATIC' as KindEnum,
        CHECK_FAILED: 'CHECK_FAILED' as KindEnum
    };
}
